import React from "react";
import { Box, Typography, TextField, Autocomplete } from "@mui/material";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function FilterSearch(props) {
  const { isSmall } = useBreakpoints();

  const Years = [
    {
      id: 1404,
      title: "1404",
    },
    {
      id: 1403,
      title: "1403",
    },
    {
      id: 1402,
      title: "1402",
    },
  ];

  const Months = [
    {
      id: 1,
      title: "فروردین",
    },
    {
      id: 2,
      title: "اردیبهشت",
    },
    {
      id: 3,
      title: "خرداد",
    },
    {
      id: 4,
      title: "تیر",
    },
    {
      id: 5,
      title: "مرداد",
    },
    {
      id: 6,
      title: "شهریور",
    },
    {
      id: 7,
      title: "مهر",
    },
    {
      id: 8,
      title: "آبان",
    },
    {
      id: 9,
      title: "آذر",
    },
    {
      id: 10,
      title: "دی",
    },
    {
      id: 11,
      title: "بهمن",
    },
    {
      id: 12,
      title: "اسفند",
    },
  ];

  return (
    <Box
      sx={{
        gap: 2,
        display: "flex",
        alignItems: "center",
        mb: 1,
        width: "100%",
      }}
    >
      <Typography variant="subtitle2">تاریخ :</Typography>
      <Autocomplete
        fullWidth
        size="small"
        value={props.state.year ? props.state.year : ""}
        onChange={(event, newValue) => {
          if (newValue || newValue == 0) {
            props.setState({ ...props.state, year: newValue });
          } else {
            props.setState({ ...props.state, year: undefined });
          }
        }}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(option) => {
          if (option) {
            return Years.find((m) => m.id == option)?.title;
          }
          return "";
        }}
        sx={{
          width: isSmall ? "40%" : "15%",
        }}
        options={Years.map((m) => m.id)}
        renderInput={(params) => (
          <TextField
            sx={{ input: { textAlign: "center" } }}
            variant="outlined"
            {...params}
            label="سال"
          />
        )}
      />
      <Autocomplete
        sx={{
          width: isSmall ? "40%" : "15%",
        }}
        fullWidth
        size="small"
        value={props.state.month ? props.state.month : ""}
        onChange={(event, newValue) => {
          if (newValue) {
            props.setState({ ...props.state, month: newValue });
          } else {
            props.setState({ ...props.state, month: undefined });
          }
        }}
        isOptionEqualToValue={(option, value) => {
          return value == "" || option === value;
        }}
        getOptionLabel={(option) => {
          if (option) {
            return Months?.find((m) => m.id == option)?.title;
          }
          return "";
        }}
        options={Months.map((m) => m.id)}
        renderInput={(params) => (
          <TextField
            sx={{ input: { textAlign: "center" } }}
            variant="outlined"
            {...params}
            label="ماه"
          />
        )}
      />
    </Box>
  );
}
